import { render } from "./AddDifficulty.vue?vue&type=template&id=851ec31e"
import script from "./AddDifficulty.vue?vue&type=script&lang=js"
export * from "./AddDifficulty.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__